import React, { useEffect, useState } from "react";

import { useBoards } from "../../../../../utils/reactQuery/boards";
import Loader from "../../../../../components/Loader";
import MuiTable from "./MuiTbale";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { Box } from "@mui/material";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useSelector } from "react-redux";
import { columns } from "./boardManagementColumns";

function Table() {
  const { isLoading, boards, isError, error, refetch } = useBoards();
  const [filterBoard] = useCustomSearchParams("boards-type");
  const isMobile = useResponsive("down", "md");
  const data = boards?.data.data.responseData;
  const [rows, setRows] = useState([]);
  const searchText = useSelector((state) => state.search.searchText);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    const boardArray = data
      ?.map((el, idx) => {
        return { ...el, id: idx };
      })
      ?.filter((board) =>
        board.board_name.toLowerCase().includes(searchText.toLowerCase())
      );

    if (filterBoard) {
      if (filterBoard === "all") {
        setRows(boardArray);
      } else {
        if (filterBoard === "active") {
          setRows(boardArray?.filter((el) => !el.is_archive));
        } else {
          setRows(boardArray?.filter((el) => el.is_archive));
        }
      }
    } else {
      setRows(boardArray);
    }
  }, [filterBoard, searchText, data]);

  return (
    <>
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && (
        <div className="loader-center">
          <p>Error</p>
        </div>
      )}
      {!isLoading && !isError && (
        <Box className={"board-table"} p={isMobile && 1} mt={isMobile && 1}>
          <MuiTable
            initialRows={rows || []}
            columns={columns(isMobile)}
            defaultSort={"board_name"}
            headerBgColor={"#F2F4F6"}
          />
        </Box>
      )}
    </>
  );
}

export default React.memo(Table);
